import styles from '../styles/IconLibrary.module.css';

type SvgProps = {
  svg?: string;
};

export const Svg = ({ svg }: SvgProps) => {
  if (svg) {
    return (
      <div className="overflow-hidden relative w-full h-full">
        <div
          className={`bg-center bg-no-repeat bg-contain h-full absolute w-full inset-0 ${styles.svg}`}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      </div>
    );
  } else {
    return null;
  }
};
